import { ShopperList } from '@/features/shoppers/ShopperList';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// The filters and the order are search params named like GET /shoppers's query parameters, so a filtered or sorted
// list is a deep link (merchant screens §3.5). An unknown channel or order is dropped.
export const Route = createFileRoute('/shoppers/')({
  staticData: { nav: 'shoppers' },
  validateSearch: z.object({
    q: z.string().optional(),
    channel: z.enum(['whatsapp', 'instagram']).optional().catch(undefined),
    tag: z.string().optional(),
    always_staff: z.string().optional(),
    sort: z.enum(['last_contact', 'name', 'sales']).optional().catch(undefined),
  }),
  component: ShopperList,
});
